<script setup lang="ts">
defineProps<{ modelValue: boolean; label: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()
</script>
<template>
  <div class="flex items-center justify-between gap-4">
    <span class="text-sm font-medium text-ink">{{ label }}</span>
    <button
      type="button"
      role="switch"
      :aria-label="label"
      :aria-checked="modelValue"
      class="relative h-6 w-11 shrink-0 rounded-full transition-colors"
      :class="modelValue ? 'bg-moss-600' : 'bg-slate-200 dark:bg-slate-600'"
      @click="emit('update:modelValue', !modelValue)"
    >
      <span
        class="absolute top-0.5 size-5 rounded-full bg-white shadow-sm transition-transform"
        :class="modelValue ? 'left-0.5 translate-x-5' : 'left-0.5'"
      />
    </button>
  </div>
</template>
